// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.card-actions[data-v-45b96bec] {\n    background-color: #b3c7cd !important;\n}\n", ""]);
// Exports
module.exports = exports;
